import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Step } from 'semantic-ui-react';

class ManagementStep extends Component {

  render() {

    const { activeStep } = this.props.StepFn;

    let step01 = '', step02 = '', step03 = '', step04 = '';

    switch (activeStep) {
      case 1:
        step01 = 'active';
        break;
      case 2:
        step01 = 'active completed';
        step02 = 'active';
        break;
      case 3:
        step01 = 'active completed';
        step02 = 'active completed';
        step03 = 'active';
        break;
      case 4:
        step01 = 'active completed';
        step02 = 'active completed';
        step03 = 'active completed';
        step04 = 'active completed';
        break;
      default:
        break;
    }

    return(

        <div>
          <Step.Group>
            <Step className={step01}>
              <Step.Content title='Step1. 엑셀파일 서식 다운로드'/>
              <Icon name='warning circle' />
            </Step>

            <Step className={step02}>
              <Step.Content title='Step2. 엑셀파일 업로드'/>
              <Icon name='warning circle' />
            </Step>

            <Step className={step03}>
              <Step.Content title='Step3. 정보 확인'/>
              <Icon name='warning circle' />
            </Step>

            <Step className={step04}>
              <Step.Content title='Step4. 등록 완료'/>
              <Icon name='warning circle' />
            </Step>
          </Step.Group>
        </div>

    );

  }

}

export default ManagementStep;
